<template>
    <div v-if="isloaded">
        <div class="index-bg">
            <bb-searchbar></bb-searchbar>
        </div>
        <div class="container mt-5 mb-5">
            <mdb-jumbotron class="mb-0">
                <div class="content-page">
                    <h4 class="page-title">{{title}}</h4>
                    <div class="row m-0">
                        <div class="col-12 col-md-6" style="border: 1px solid #ccc;border-radius: 6px;">
                            <mdb-input label="Adınız Soyadınız"  type="text" v-model="name" />
                            <div class="red-text" v-show="nameR">
                                Lütfen Ad Soyad alanını doldurunuz.
                            </div>
                            <mdb-input label="E-posta Adresiniz"  type="email" v-model="email" />
                            <div class="red-text" v-show="emailR">
                                Lütfen E-posta alanını doğru şekilde giriniz.
                            </div>
                            <mdb-input label="Telefon Numaranız"  type="text" v-model="phone" v-mask="'5## ### ## ##'" />
                        </div>
                        <div class="col"></div>
                        <div class="col-12 col-md-5 blue-grey lighten-5 p-0" style="border-radius: 6px">
                            <h4 class="biletbul-bg-blue p-3" style="border-radius: 6px">Toplam MilPuan: <span class="float-right">{{icerik.miles}}</span></h4>
                            <p class="p-3">MilPuan demek bedeva uçuş hakkı demek. Uçuşlarınızı BiletBul.com üzerinden yapın, topladığınız
                                MilPuanlar ile sonraki uçuşunuz bedavaya gelsin</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="fatura-want" value="true" v-model="if_company" @click="collapse2 === true ? collapse2 = false : collapse2 = true"/>
                            <label class="custom-control-label" for="fatura-want"> Tüzel Kişiliğim</label>
                        </div>
                    </div>
                    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                        <div v-if="collapse2" class="collapse-item mt-2">
                            <div class="row m-1" style="background-color: aliceblue;padding: 10px;">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="billing_name">Firma Ünvan/Kişi Adı soyadı </label>
                                        <input type="text" id="billing_name" class="form-control"
                                               name="billing_name" v-model="billing_title">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="tax_office">Vergi Dairesi </label>
                                        <input type="text" id="tax_office" class="form-control"
                                               name="tax_office" v-model="billing_tax_office">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="tax_number">Vergi/TCK no </label>
                                        <input type="text" id="tax_number" class="form-control"
                                               name="tax_number" v-model="billing_tax_number">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="address_detail">Adres </label>
                                        <input type="text" id="address_detail" class="form-control"
                                               name="address_detail" v-model="billing_address">
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="zip_code">Posta kodu </label>
                                        <input type="text" id="zip_code" class="form-control"
                                               name="zip_code" v-model="billing_zip_code">
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="address_district">İlçe </label>
                                        <input type="text" id="address_district" class="form-control"
                                               name="address_district" v-model="billing_district">
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="city">Şehir </label>
                                        <input type="text" id="city" class="form-control"
                                               name="city" v-model="billing_city">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div class="text-right">
                        <mdb-btn color="biletbul-bg-blue" type="button" @click="updateProfile">Güncelle</mdb-btn>
                    </div>
                </div>
            </mdb-jumbotron>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbCollapse } from 'mdbvue';
    import searchBar from '@/components/searchBar';
    import {TheMask} from 'vue-the-mask';

    export default {
        name: "profilePage.vue",
        metaInfo() {
            return {
                title: "Profilim",
                meta: [
                    { name: 'description', content:  ""},
                    { name: 'keywords', content:  ""},
                    { property: 'og:title', content: ""},
                    { property: 'og:site_name', content: 'Biletbul'},
                    {property: 'og:type', content: 'website'},
                    {name: 'robots', content: 'index,follow'}
                ]
            }
        },
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbCollapse,
            'bb-searchbar':searchBar,
            TheMask
        },
        data() {
            return {
                title: "Profilim",
                modal: false,
                toggle: false,
                isloaded : false,
                icerik:[],
                name:"",
                email:"",
                phone:"",
                billing_title:"",
                billing_tax_office:"",
                billing_tax_number:"",
                billing_city:"",
                billing_district:"",
                billing_zip_code:"",
                billing_address:"",
                nameR:false,
                emailR:false,
                collapse2: false,
                if_company: false,
            };
        },
        mounted() {
            this.getPageData();
        },
        methods:{
            updateProfile(){
                let self = this;
                axios.post("https://www.biletbul.com/backend/public/api/v1/update_user",{
                    api_token:localStorage.api_token,
                    name:self.name,
                    email:self.email,
                    phone:self.phone,
                    billing_title:self.billing_title,
                    billing_tax_office:self.billing_tax_office,
                    billing_tax_number:self.billing_tax_number,
                    billing_city:self.billing_city,
                    billing_district:self.billing_district,
                    billing_zip_code:self.billing_zip_code,
                    billing_address:self.billing_address,
                })
            },
            beforeEnter(el) {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width>768){
                    this.elHeight = 300;
                }else{
                    this.elHeight = 645;
                }
            },
            enter(el) {
                el.style.height = this.elHeight+'px';
            },
            beforeLeave(el) {
                el.style.height = 0;
            },
            getPageData(){
                let self = this;
                axios.post("https://www.biletbul.com/backend/public/api/v1/get_user_by_token",{
                    api_token:localStorage.api_token
                })
                    .then((response) => {
                        this.isloaded = true;
                        if(response.data.status == true){
                            self.icerik = response.data.data;
                            self.name = self.icerik.name;
                            self.email = self.icerik.email;
                            if(self.icerik.billing_title){
                                self.if_company=true;
                                self.collapse2=true;
                                self.billing_title=self.icerik.billing_title;
                                self.billing_tax_office=self.icerik.billing_tax_office;
                                self.billing_tax_number=self.icerik.billing_tax_number;
                                self.billing_city=self.icerik.billing_city;
                                self.billing_district=self.icerik.billing_district;
                                self.billing_zip_code=self.icerik.billing_zip_code;
                                self.billing_address=self.icerik.billing_address;
                            }

                            if(!self.icerik.miles){
                                self.icerik.miles = 0;
                            }
                        }
                    });
            }
        },
        watch:{
        }
    };
</script>

<style scoped>

</style>